import { LGPlatformEnum } from './constant'

/**
 * @description: 语言SDK配置文件
 */
const config = {
  aliOssBaseURL: import.meta.env.VITE_LG_ALI_OSS_BASE_URL,
  aliOssAccBaseURL: import.meta.env.VITE_LG_ALI_OSS_ACC_BASE_URL,
  locale: 'en',
  platform: LGPlatformEnum.META_EDITER,
  addCodes: [
    {
      code: 'tr',
      name: '土耳其语',
      browserCodes: 'tr,tr-tr'
    },
    {
      code: 'vi',
      name: '越南语',
      browserCodes: 'vi,vi-vn'
    },
    {
      code: 'th',
      name: '泰语',
      browserCodes: 'th,th-th'
    },
    {
      code: 'tl',
      name: '菲律宾语',
      browserCodes: 'tl,fil,tl-ph,fil-ph'
    },
    {
      code: 'hi',
      name: '印度语',
      browserCodes: 'hi,hi-in'
    },
    {
      code: 'ko',
      name: '韩语',
      browserCodes: 'ko,ko-kr'
    },
    {
      code: 'pt',
      name: '葡萄牙语',
      browserCodes: 'pt,pt-br,pt-pt'
    },
    {
      code: 'es',
      name: '西班牙语',
      browserCodes: 'es,es-ar,es-bo,es-cl,es-co,es-cr,es-do,es-ec,es-es,es-es,es-gt,es-hn,es-mx,es-ni,es-pa,es-pe,es-pr,es-py,es-sv,es-uy,es-ve'
    }
  ],
  customLocale: {
    'zh-Hans': 'zh',
    'zh-Hant': 'zh'
  }
}

export default config
